export default "__VITE_ASSET__BIfd5HEs__"